import LinkExpiredView from 'src/sections/team-invite/view/link-expired-view';

export default function LinkExpiredPage() {
  return <LinkExpiredView />;
}
